// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.optionsmenudiv
{
    width: 100%;
    height: 100%;
    padding-top: 10px;
    -webkit-user-select: none;
            user-select: none;
    overflow-x: hidden;

    /* Firefox */
    scrollbar-width: none;
    /* IE / Edge ancien */
    -ms-overflow-style: none;   
}

.optionsmenudiv2
{
    height: 100%;
    width: 100%;
    
}

.optionsmenudiv2a
{
    width: 100%;
    height: 30%;
    
    overflow-x: hidden;
    -webkit-user-select: none;
            user-select: none;
    /* Firefox */
    scrollbar-width: none;
    /* IE / Edge ancien */
    -ms-overflow-style: none;   

    

}
.optionsmenudiv2b
{
    width: 100%;
    height: 67%;
    margin-top: "5px";
    border-color: #AAAAAA ;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    
    
    
}


.optionsmenudiv::-webkit-scrollbar {
  display: none;
}

.optionsmenudiv2a::-webkit-scrollbar {
  display: none;
}


.optionsmenu
{
    text-align: left;
    padding-left: 20px;
    padding-top: 5px;
    padding-bottom: 2px;
}
.optionsmenu:hover
{
 text-shadow:
    0 2px 4px rgba(200, 200, 200, 1),  /* ombre vers le bas */
    0 0 10px rgba(200,200,200,0.5);   /* halo doux */
}



.optionssubmenu
{
    text-align: left;
    padding-left: 50px;
    
    
}
.optionssubmenu:hover
{
 text-shadow:
    0 2px 4px rgba(255, 200, 200, 1),  /* ombre vers le bas */
    0 0 10px rgba(255,200,200,0.5);   /* halo doux */}

.optionssubmenuunselected
{
    font-size: 12px;

}


.optionssubmenuselected
{
    font-size: 12px;
    border-radius: 5px;
    background-color: var(--default-icon-color);
    padding-top: 0px;
    padding-left: 3px;
    padding-right: 3px;
    color:black;

}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/optionsmenu.css"],"names":[],"mappings":";;;AAGA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;;IAElB,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;;IAEI,YAAY;IACZ,WAAW;;AAEf;;AAEA;;IAEI,WAAW;IACX,WAAW;;IAEX,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;;;;AAI5B;AACA;;IAEI,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;;;;AAIvB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;AAGA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;CAEC;;kCAEiC,IAAI,cAAc;AACpD;;;;AAIA;;IAEI,gBAAgB;IAChB,kBAAkB;;;AAGtB;AACA;;CAEC;;kCAEiC,IAAI,cAAc,CAAC;;AAErD;;IAEI,eAAe;;AAEnB;;;AAGA;;IAEI,eAAe;IACf,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;;AAEf","sourcesContent":["\n\n\n.optionsmenudiv\n{\n    width: 100%;\n    height: 100%;\n    padding-top: 10px;\n    user-select: none;\n    overflow-x: hidden;\n\n    /* Firefox */\n    scrollbar-width: none;\n    /* IE / Edge ancien */\n    -ms-overflow-style: none;   \n}\n\n.optionsmenudiv2\n{\n    height: 100%;\n    width: 100%;\n    \n}\n\n.optionsmenudiv2a\n{\n    width: 100%;\n    height: 30%;\n    \n    overflow-x: hidden;\n    user-select: none;\n    /* Firefox */\n    scrollbar-width: none;\n    /* IE / Edge ancien */\n    -ms-overflow-style: none;   \n\n    \n\n}\n.optionsmenudiv2b\n{\n    width: 100%;\n    height: 67%;\n    margin-top: \"5px\";\n    border-color: #AAAAAA ;\n    border-radius: 4px;\n    border-width: 1px;\n    border-style: solid;\n    \n    \n    \n}\n\n\n.optionsmenudiv::-webkit-scrollbar {\n  display: none;\n}\n\n.optionsmenudiv2a::-webkit-scrollbar {\n  display: none;\n}\n\n\n.optionsmenu\n{\n    text-align: left;\n    padding-left: 20px;\n    padding-top: 5px;\n    padding-bottom: 2px;\n}\n.optionsmenu:hover\n{\n text-shadow:\n    0 2px 4px rgba(200, 200, 200, 1),  /* ombre vers le bas */\n    0 0 10px rgba(200,200,200,0.5);   /* halo doux */\n}\n\n\n\n.optionssubmenu\n{\n    text-align: left;\n    padding-left: 50px;\n    \n    \n}\n.optionssubmenu:hover\n{\n text-shadow:\n    0 2px 4px rgba(255, 200, 200, 1),  /* ombre vers le bas */\n    0 0 10px rgba(255,200,200,0.5);   /* halo doux */}\n\n.optionssubmenuunselected\n{\n    font-size: 12px;\n\n}\n\n\n.optionssubmenuselected\n{\n    font-size: 12px;\n    border-radius: 5px;\n    background-color: var(--default-icon-color);\n    padding-top: 0px;\n    padding-left: 3px;\n    padding-right: 3px;\n    color:black;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
